/**
 * Created by mukund on 6/10/15.
 */
'use strict';

angular.module('mediacloudApp')
    .controller('FooterController', function ($scope, $location, $state, Auth, Principal) {
        $scope.isAuthenticated = Principal.isAuthenticated;
        $scope.$state = $state;
        $scope.date = new Date().getFullYear();
    });
